var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Response',{attrs:{"view":"success","title":"Оплата прошла успешно!","description":"Квитанцию и другую информацию по платежу вы можете посмотреть в приложении банка","button-text":"Вернуться в магазин","button-href":_vm.state.merchant.link}})
}
var staticRenderFns = []

export { render, staticRenderFns }